const translations = {
    applications: 'Applications',
    editField: 'Edit Field',
    linkedEntities: 'Linked Entities'
};

export default translations;
